export const PAYMENT_METHODS = {
  offline: "offline",
  online: "online",
};

export const EVIDENCE_ACCEPT = ".pdf,.jpg,.jpeg,.png";
